import React, { Fragment, useState } from "react";
import "./styles.css";
import { ReactComponent as Cancel } from "common/assets/svg/cancel.svg";
import { useTransition, animated } from "react-spring";
import { ReactComponent as Back } from "common/assets/svg/leftArrow.svg";
import CartCustomisation from "pages/order/cartCustomisation";
import { CartItemOption } from "common/features/cart/cartModels";
import PreviewItem from "pages/order/previewItem";

interface ConfirmationPromptProps {
  isOpen: boolean;
  onClose: any;
  itemId: any;
  setOpenCustomisation?: any;
}

function PreviewItemPrompt(props: ConfirmationPromptProps) {
  const { isOpen, onClose, itemId, setOpenCustomisation } = props;

  const [customizationAlert, setcustomizationAlert] = useState(false);


  const transitions = useTransition(isOpen, null, {
    from: { transform: "translate3d(0,-15px,0)", opacity: 0.4 },
    enter: { transform: "translate3d(0,0px,0)", opacity: 1 },
    leave: { transform: "translate3d(0,-15px,0)", opacity: 0 },
    unique: true,
  });

  const ColoredLine = ({ color }: any) => (
    <hr
      style={{
        color,
        backgroundColor: "#E0E0E0",
        height: 1,
        marginTop: 10,
      }}
    />
  );

  return (
    <Fragment>
      <Fragment>
        {isOpen ? <div id="modal-background"></div> : null}
        {transitions.map(({ item, key, props }) =>
          item ? (
            <animated.div className="desktop-customisation-CPWrapper">
              <animated.div
                className="desktop-customisation-CPContainer"
                style={{ ...props }}
                key={key}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "20px 32px 12px 32px",
                    position: "sticky",
                    top: "0",
                    backgroundColor: "#fff",
                    zIndex: "9",
                  }}
                >
                  <Back
                    onClick={() => {
                      // history.goBack();
                      // goToRestauratMenu(false);
                      onClose(true);
                      // setTimeout(() => {
                      //   if (isContactlessDineInOrder) {

                      //     history.push(
                      //       getRestaurantMenuURLWithTableID(
                      //         "restaurant",
                      //         restaurantSlug,
                      //         tableId,
                      //         menuType
                      //       )
                      //     );
                      //   } else {

                      //     history.push({
                      //       pathname: getMerchantMenuURL(restaurantSlug, menuType),
                      //       state: { loadMenuRequired: false } as MenuRouteState,
                      //     });
                      //   }
                      // }, 1000);
                    }}
                  />
                  <span className="desktop-customisation-heading-text">
                    
                  </span>
                  <Cancel onClick={() => onClose(true)} />
                </div>
                <div style={{ margin: '0 20px' }}>
                  <ColoredLine color="#DCDCDC" />
                </div>
                <PreviewItem onClose={onClose} itemId={itemId} customizationAlert={customizationAlert} setcustomizationAlert={setcustomizationAlert} setOpenCustomisation={setOpenCustomisation} />
              </animated.div>
            </animated.div>
          ) : null
        )}
      </Fragment>
    </Fragment>
  );
}

export default PreviewItemPrompt;
